import { Dispatch, SetStateAction, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, CardMedia, Input } from "@mui/material";
import { isValidInput } from "../utils/validations";
import { showError } from "../constants/toasts";
import { UploadMedia } from "../utils/mediaUpload";

interface AddFacilityModalProps {
  open: boolean;
  value: string;
  facilityImage?: string;
  loading: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  edit?: boolean;
  handleSubmit: (name: string, image ?: string) => void;
  setFacilityName?: Dispatch<SetStateAction<string>> | null;
}

export default function AddFacility({
  open,
  value,
  facilityImage,
  loading,
  onClose,
  setOpen,
  handleSubmit,
  edit,
  setFacilityName,
}: AddFacilityModalProps) {
  const [name, setName] = useState("");
  const [image, setImage] = useState<string>("");

    const handleImageUpload = async (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      const file = event.target?.files?.[0];
      if (!file) return;
      const imageUrl = (await UploadMedia(file)) as any;
      if (imageUrl?.data) {
        setImage(imageUrl.data);
      }
    };

  useEffect(() => {
    if (open) {
      if (edit && value?.length) {
        setName(value);
        setImage(facilityImage || "");
      } else {
        setName("");
        setImage("");
      }
    }
  }, [open, edit, value, facilityImage]);

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>
              {edit
                ? `Edit Facility`
                : `Add Facility`}
            </h2>
            <div className="btn-close" onClick={onClose}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
                        <div className="control_group w_100">
                          <label>Upload Facility Image</label>
                          {image ? (
                            <div className="upload_image">
                              <div className="upload_image_holder">
                                <figure>
                                  <CardMedia component="img" image={image} alt="Banner" />
                                </figure>
                                <CloseIcon
                                  onClick={() => {
                                    setImage("");
                                  }}
                                />
                              </div>
                            </div>
                          ) : (
                            <label className="upload_image" htmlFor="icon-button-file">
                              <Input
                                id="icon-button-file"
                                type="file"
                                sx={{ display: "none" }}
                                inputProps={{ accept: "image/png,image/jpeg" }}
                                onChange={(event) => {
                                  handleImageUpload(event as any);
                                  event.target.value = image ||"";
                                }}
                              />
                              <span className="upload_image_holder">
                                <figure className="add_img">
                                  <img src="/static/images/placeholder.png" alt="icon" />
                                  <span className="upload_img_icon">
                                    <img src="/static/images/edit2_icon.svg" alt="edit" />
                                  </span>
                                </figure>
                              </span>
                            </label>
                          )}
                        </div>
            <div className="control_group">
              <label>{`Facility Name`}</label>
              <TextField
                value={name}
                onChange={(e) => {
                  if (isValidInput(e.target.value)) {
                    setName(e.target.value);
                  }
                }}
                placeholder={`Enter Facility Name`}
                fullWidth
                hiddenLabel
              ></TextField>
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={onClose}>
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => {
                  if (!name?.length) {
                    showError("Name is required.");
                    return;
                  }
                  if (name?.length < 3) {
                    showError("Please enter a valid Name.");
                    return;
                  }

                  handleSubmit(name, image);
                  setName("");
                  if (setFacilityName) {
                    setFacilityName("");
                  }
                }}
                disabled={loading}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
